var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"notFound"},[_c('h1',[_vm._v("404")]),_c('p',[_vm._v("ページが見つかりませんでした。")]),_c('p',[_vm._v("Page non trouvée.")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Home")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }